<template>
  <v-card elevation="2" rounded class="mb-4" :loading="isSaving">
    <v-tabs v-model="activeTab" slider-size="4" slider-color="blue">
      <v-tab
        v-if="hasErrors"
        active-class="grey--text text--darken-4"
        @click="trackTabClick('needReviewTab')"
        >{{
          $t('common.users.need_review_count', { count: totalUsersWithErrors })
        }}</v-tab
      >
      <v-tab
        active-class="grey--text text--darken-4"
        @click="trackTabClick('readyTab')"
        >{{
          $t('common.users.ready_count', { count: totalUsersWithoutErrors })
        }}</v-tab
      >
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item v-if="hasErrors" class="pa-4">
        <UserForm
          v-for="(account, index) in usersWithErrors"
          fullWidth
          :canAssignRole="canAssignRole"
          :account="account"
          :defaultSiteId="defaultSiteId"
          :key="index"
          :index="index + 1"
          :rolesEnabled="rolesEnabled"
          :showRemove="userList.length > 1"
          :active="index === activeIndex"
          @change="
            $emit('onChange', {
              value: $event,
              originalIndex: account.originalIndex,
              isDuplicated: account.isDuplicated,
            })
          "
          @remove="$emit('removeUser', account.originalIndex)"
          @click.native="activeIndex = index"
        />
      </v-tab-item>
      <v-tab-item>
        <v-container fluid v-if="hasNoErrors">
          <SuccessfullUsers
            :showRoleColumn="canAssignRole"
            :userList="usersWithoutErrors"
          />
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import _ from 'lodash'

import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import SuccessfullUsers from './SuccessfullUsers.vue'
import UserForm from '@/components/People/UserForm.vue'

export default {
  name: 'UserTable',

  mixins: [trackerMixin],

  components: {
    SuccessfullUsers,
    UserForm,
  },

  props: {
    userList: {
      type: Array,
      default() {
        return []
      },
    },

    rolesEnabled: {
      type: Array,
      required: false,
      default() {
        return ['isCoach']
      },
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    canAssignRole: {
      type: Boolean,
      default: false,
    },
    defaultSiteId: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      activeTab: 0,
      activeIndex: -1,
    }
  },

  computed: {
    usersWithErrors() {
      return this.userList?.filter(user => user?.hasError) ?? []
    },

    usersWithoutErrors() {
      return this.userList?.filter(user => !user?.hasError) ?? []
    },

    totalUsersWithErrors() {
      return this.usersWithErrors.length
    },

    totalUsersWithoutErrors() {
      return this.usersWithoutErrors.length
    },

    hasErrors() {
      return !_.isEmpty(this.usersWithErrors)
    },

    hasNoErrors() {
      return !_.isEmpty(this.usersWithoutErrors)
    },
  },

  methods: {
    trackTabClick(tab) {
      this.trackAddPeopleNavigate({
        section: 'usersTable',
        element: tab,
      })
    },
  },
}
</script>
